export default function CTASection() {
  return (
    <section className="relative h-[500px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20fashion%20texture%20with%20flowing%20silk%20fabric%20drapes%20in%20terracotta%20sand%20and%20cream%20hues%20soft%20diffused%20lighting%20from%20above%20creating%20gentle%20highlights%20and%20deep%20folds%20editorial%20textile%20photography%20with%20organic%20movement%20luxurious%20tactile%20quality%20and%20ethereal%20dreamy%20atmosphere%20no%20recognizable%20products%20just%20artistic%20fabric%20waves&width=1800&height=1200&seq=cta-bg-v3&orientation=landscape"
          alt="CSSBuy Spreadsheet Shopping"
          title="Shop the CSSBuy Sheets"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/20 to-foreground-950/45" />

      <div className="relative z-10 text-center px-4 w-full">
        <h2 className="font-heading text-3xl md:text-6xl font-bold text-background-50 tracking-wide mb-4">
          SHOP THE SHEETS
        </h2>
        <p className="text-sm md:text-base text-background-200 max-w-lg mx-auto leading-relaxed mb-8">
          Curated CSSBuy Links for Every Category<br />
          Updated Weekly by Real Buyers
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer group"
        >
          <span className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
            <i className="ri-shopping-bag-line text-background-50 text-sm"></i>
          </span>
          <span>BUY IT NOW</span>
          <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
        </a>
      </div>
    </section>
  );
}